import { QueryClientProvider } from '@tanstack/react-query';
import { trpc } from './lib/trpc';
import { RouterProvider } from 'react-router-dom';
import { router } from './lib/react-router-dom';
import useTrpc from './lib/trpc';
import { ThemeProvider } from './utils/theme-provider';
import './lib/i18next';
import { Toaster } from 'sonner';

export function App() {
	const { trpcClient, queryClient } = useTrpc();

	return (
		<trpc.Provider client={trpcClient} queryClient={queryClient}>
			<QueryClientProvider client={queryClient}>
				<ThemeProvider defaultTheme="system" storageKey="vite-ui-theme">
					<div className="flex h-full w-full">
						<RouterProvider router={router} />
						<Toaster position="top-right" />
					</div>
				</ThemeProvider>
			</QueryClientProvider>
		</trpc.Provider>
	);
}

export default App;
